
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tier-list/augments/[id]",
      function () {
        return require("private-next-pages/tier-list/augments/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tier-list/augments/[id]"])
      });
    }
  